import { useState, useCallback } from 'react'

const INITIAL = {
	customerName: '',
	customerEmail: '',
	customerTel: '',
	source: '',
	campaign: '',
	status: 'new',
	note: '',
}

export default function useLeadFormState(initial = INITIAL) {
	const [form, setForm] = useState(initial)

	const setField = useCallback((name, value) => {
		setForm(prev => ({ ...prev, [name]: value }))
	}, [])

	const reset = useCallback(() => setForm(INITIAL), [])

	return { form, setField, setForm, reset }
}
